"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var CategoryItem2_1 = __importDefault(require("./CategoryItem2"));
var react_aim_1 = require("react-aim");
// @ts-ignore
var CategoryItem2List = /** @class */ (function (_super) {
    __extends(CategoryItem2List, _super);
    function CategoryItem2List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoryItem2List.prototype.render = function () {
        var _this = this;
        var _a = this.props.productCategory, name = _a.name, displayCategoryId = _a.displayCategoryId, children = _a.children;
        var catId = '' + displayCategoryId;
        if (catId.length == 1) {
            catId = '0' + catId;
        }
        var className = "categorySecondLayer cat" + catId;
        var rows = children.map(function (productCategory, index) {
            return (react_1.default.createElement(CategoryItem2_1.default, { key: index, parentDisplayCategoryId: displayCategoryId, productCategory: productCategory, disableMarketplaceBanner: _this.props.disableMarketplaceBanner }));
        });
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement("p", { className: "name" }, name),
            rows));
    };
    CategoryItem2List.propTypes = {
        productCategory: prop_types_1.default.shape({
            name: prop_types_1.default.string.isRequired,
            displayCategoryId: prop_types_1.default.number.isRequired,
            itemCount: prop_types_1.default.number.isRequired,
            disableMarketplaceBanner: prop_types_1.default.bool,
            children: prop_types_1.default.arrayOf(prop_types_1.default.shape({
                name: prop_types_1.default.string.isRequired,
                displayCategoryId: prop_types_1.default.number.isRequired,
                itemCount: prop_types_1.default.number.isRequired,
            })).isRequired,
        }),
    };
    CategoryItem2List = __decorate([
        react_aim_1.target()
    ], CategoryItem2List);
    return CategoryItem2List;
}(react_1.default.Component));
exports.default = CategoryItem2List;
